export default {"src":"/_next/static/media/Iowa.b383777f.svg","height":385,"width":800,"blurWidth":0,"blurHeight":0};